module.exports = __webpack_public_path__ + "static/media/leona.8ef7fab6.png";